import { global } from "../../actionTypes";

export const setRoute = (path) => (dispatch) => dispatch({ type: global.SET_ROUTE, data: path });

export const setTest = (path) => (dispatch) => dispatch({ type: global.SET_ROUTE, data: path });

export const setSnackBarNotifications = (data) => (dispatch) => {
  dispatch({ type: global.SHOW_SNACKBAR, data });
};
